<template>

  <div class="tool">

    <div class="tool-header">
      <h4>控件设置</h4>


<!--      <div class="btn" style="position: absolute; right: 5px; top: 4px; width: 80px" @click="closeEvent">确定</div>-->
      <a class="close" @click="closeEvent">x</a>
    </div>

    <div class="tool-box">


      <div class="ControlLibrary"  >


            <ControlLibraryInput
                name="*名称"
                placeholder="请输入名称"
                field="name"
                :value="field.name"
                @update="update"
            ></ControlLibraryInput>


            <ControlLibrarySelect
                name="*是否必填"
                field="is_require"
                :value="field.is_require"
                :option-data="[  { name : '选填', value : -1 }, { name : '必填', value : 1 } ]"
                @update="update"
            ></ControlLibrarySelect>


            <ControlLibrarySelect
                name="*类型"
                field="type"
                :option-data="library"
                :value="field.type"
                @update="update"
            ></ControlLibrarySelect>


            <div class="xian"></div>

            <!--        附加属性-->

            <ControlLibrarySelect
                v-if="field.option.display_date===1"
                name="时间格式"
                field="date"
                :value="field.option.date"
                :option="[ 'YYYY/MM/DD', 'YYYY-MM-DD', 'YYYY年MM月DD日']"
                @update="updateOption"
            ></ControlLibrarySelect>

            <ControlLibrarySelect
                v-if="field.option.display_number===1"
                name="数字格式"
                field="font_number"
                :value="field.option.font_number"
                :option-data="[  { name : '默认', value : -1 }]"
                @update="updateOption"
            ></ControlLibrarySelect>

            <ControlLibrarySelect
                v-if="field.option.display_money===1"
                name="金额格式"
                field="font_money"
                :value="field.option.font_money"
                :option-data="[  { name : '默认', value : -1 }]"
                @update="updateOption"
            ></ControlLibrarySelect>

            <!--        合同编号-->
            <ControlLibraryInput
                v-if="field.option.display_doc_number===1"
                name="合同编号-前缀"
                placeholder="合同编号前缀:如2020, 可为空"
                field="doc_number_prefix"
                :value="field.option.doc_number_prefix"
                @update="updateOption"
            ></ControlLibraryInput>

            <ControlLibrarySelect
                v-if="field.option.display_doc_number===1"
                name="合同编号-自增长度"
                field="doc_number_length"
                :value="field.option.doc_number_length"
                :option="option.doc_number_length_list"
                @update="updateOption"
            ></ControlLibrarySelect>


            <ControlLibraryInput
                v-if="field.option.display_doc_number===1"
                name="合同编号-后缀"
                placeholder="合同编号后缀, 可为空"
                field="doc_number_suffix"
                :value="field.option.doc_number_suffix"
                @update="updateOption"
            ></ControlLibraryInput>



          <div class="btn" style="margin-top: 15px; margin-bottom: 30px; max-width: 100%;" @click="closeEvent">确定</div>


            <!--        控件内容结束-->

          <!--      <div v-else>-->
          <!--        <p class="des text-center" style="margin-top: 40%; color:#000000">请将控件拖动到模板文件中<br/>或选中模板文件中的控件</p>-->
          <!--      </div>-->
        </div>
    </div>
  </div>

</template>

<script>
import ControlLibrarySelect from "./ControlLibrarySelect";
import ControlLibraryInput from "./ControlLibraryInput";
export default {
  name: "v3right",
  components: {ControlLibraryInput, ControlLibrarySelect},
  props : ["library" ,"field","option"],
  methods : {

    closeEvent() {
        this.$emit("closeEvent");
    },
    update (e) {
      this.$emit("update", e)
    },
    updateOption (e) {
      this.$emit("updateOption", e)
    }
  }
}
</script>


<style >


.ControlLibrary .des {
  font-size: 13px;
  color: #828181;
}

.ControlLibraryList li {
  border-radius: 3px;
  border: 1px dashed rgba(0, 0, 0, .3);
  margin-top: 15px;
  padding: 6px 15px 6px 15px;
  list-style: none;
}

.ControlLibraryList li:hover {
  border: 1px dashed var(--blue);
  cursor: move;
  color: var(--blue);
}

.m-from-box {
  padding-left: 0;
  padding-right: 0;
  overflow: auto;
}



.xian {
  margin-top: 20px;
  margin-bottom: 20px;
  width: 100%;
  text-align: center;
  height: 5px;
  border-bottom: 1px solid rgb(223, 223, 223);
}


.tool {
  height: 65%;
  max-height: 470px;
  background: #f3f3f3;
  z-index: 12;
  position: fixed;
  max-width: 450px;
  margin: 0 auto;
  left:0;
  right:0;
  bottom:1px;
  border-radius: 4px;
  width: 100%;
  box-shadow: 0 30px 35px rgba(0,0,0,.1);
  -webkit-transition: height .2s cubic-bezier(0,0,.2,1) 0s;
  transition: height .2s cubic-bezier(0,0,.2,1) 0s;

  animation: fadeIn 0.5s;
}

.tool h4 {
  font-size: 16px;
  color: inherit;
  font-weight: 500;
  font-family: inherit;
  line-height: 1.2;
  text-align: left;
}
.tool-box {
  overflow: auto;
  height: 100%;
}

.tool-header {
  padding: 15px 15px;
  background: #dfdfdf;
}
.ControlLibrary {
  padding: 15px 20px 50px 20px;
  max-width: 350px;
  margin: 0 auto;
}

.close {
  position: absolute;
  right: 0;
  top: 0;
  font-size: 14px;
  cursor: pointer;
  width: 40px;
  height: 40px;
  display: block;
  text-align: center;
  line-height: 47px;
}
</style>

